// extracted by mini-css-extract-plugin
export default {"termsbody":"TnC_termsbody__WZrhY","container1":"TnC_container1__zAQK5","container":"TnC_container__Zc++9","head":"TnC_head__iUNzT","autonix":"TnC_autonix__HVUc2"};